import { BaseRequest } from './BaseRequest';

export class ApplicationRequest extends BaseRequest {
    
}